module.exports = __webpack_public_path__ + "static/img/ptGame3.b122a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame3.png
// module id = V4lx
// module chunks = 3